import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonComponent } from 'src/app/shared/components/common-component';
import { PetDatesUtils } from 'src/app/shared/utils/dates.utils';
import { AtencionService } from 'src/core/atencion/atencion.service';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { Consulta } from 'src/core/consulta/consulta.types';
import { UserService } from 'src/core/user/user.service';
import { User } from 'src/core/user/user.types';

@Component({
  selector: 'app-historial-citas',
  templateUrl: './historial-citas.component.html',
  styleUrls: ['./historial-citas.component.css']
})
export class HistorialCitasComponent extends CommonComponent implements OnInit{

  consultas: Consulta[] = [];
  userSession: User = {} as User;

  constructor(
    private _consultaService: ConsultaService,
    private _dateUtilsService: PetDatesUtils,
    private _userService: UserService,
    private _atencionService: AtencionService,
    _snackBar: MatSnackBar
  ){
    super(_snackBar);
  }

  ngOnInit(): void {
    this.getConsultas();
    this.getUserSession();
  }

  getUserSession(){
    this._userService.user_session$.subscribe({
      next: (user: User) => {
        this.userSession = user;
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }

  getConsultas(){
    this._consultaService._consultasUsuarioVet$.subscribe({
      next: (consultas: Consulta[]) => {
        consultas.forEach(obj => {
          obj.showComponent = true;
          //obj.consultaNombreAtencion = this._atencionService.getAtencionByIdInList(obj.consultaIdAtencion).nombre;
        });
        this.consultas = consultas;
      },
      error: (error: any) => {
        console.log('error : ', error);
        this.openSnackBar(error.toString());
      }
    });
  }
  orderByDate( orden) {
    this.consultas = this.consultas.sort((a, b) => {

      const fechaA: Date = this._dateUtilsService.createDateFromDateAndTime(a.consultaFechaCita, a.consultaHoraCita);
      const fechaB: Date = this._dateUtilsService.createDateFromDateAndTime(b.consultaFechaCita, b.consultaHoraCita);

      if (orden === 'asc') {
        return fechaA.getTime() - fechaB.getTime();
      } else if(orden === 'desc') {
        return fechaB.getTime() - fechaA.getTime();
      }
    });
  }

  searchEvt(event: any){
    var word = event.target.value?.toLowerCase();
    for(let i = 0; i < this.consultas.length; i++){
      if(this.consultas[i].consultaNombreAtencion.toLowerCase().includes(word) || word.length === 0){
        this.consultas[i].showComponent = true;
      }else{
        this.consultas[i].showComponent = false;
      }
    }
  }

}
